const blogs = 
[
  {
    "id": 1,
    "slug": "afazi-turleri",
    "title": "1Afazi Türleri Nelerdir? 5 Ana Tip ve Ayırt Edici Özellikleriyle Kapsamlı Rehber",
    "metaDescription": "Afazi türleri hakkında merak ettiğiniz her şey burada! Broca, Wernicke, Global ve diğer afazi çeşitlerini belirtileriyle birlikte öğrenin.",
    "keywords": ["Afazi türleri", "Broca afazisi", "Wernicke afazisi", "Global afazi", "Afazi nedir"],
    "category": "Blog Yazıları",
    "image": "/images/afazi-turleri.png",
    "date": "2025-07-30",
    "featured": true,
    "content": "<h2>Afazi Nedir?</h2><p>Afazi, beyin hasarı sonucu dil becerilerinin etkilenmesiyle oluşur...</p>"
  },
    {
    "id": 2,
    "slug": "afazi-turleri",
    "title": "2Afazi Türleri Nelerdir?",
    "metaDescription": "Afazi türleri hakkında merak ettiğiniz her şey burada! Broca, Wernicke, Global ve diğer afazi çeşitlerini belirtileriyle birlikte öğrenin.",
    "keywords": ["Afazi türleri", "Broca afazisi", "Wernicke afazisi", "Global afazi", "Afazi nedir"],
    "category": "Blog Yazıları",
    "image": "/blog/afazi-turleri3.png",
    "date": "2025-07-30",
    "featured": false,
    "content": "<h2>Afazi Nedir?</h2><p>Afazi, beyin hasarı sonucu dil becerilerinin etkilenmesiyle oluşur...</p>"
  },
    {
    "id": 3,
    "slug": "afazi-turleri",
    "title": "3Afazi Türleri Nelerdir? 5 Ana Tip ve Ayırt Edici Özellikleriyle Kapsamlı Rehber",
    "metaDescription": "Afazi türleri hakkında merak ettiğiniz her şey burada! Broca, Wernicke, Global ve diğer afazi çeşitlerini belirtileriyle birlikte öğrenin.",
    "keywords": ["Afazi türleri", "Broca afazisi", "Wernicke afazisi", "Global afazi", "Afazi nedir"],
    "category": "Bültenler",
    "image": "/images/afazi-turleri.png",
    "date": "2025-07-30",
    "featured": false,
    "content": "<h2>Afazi Nedir?</h2><p>Afazi, beyin hasarı sonucu dil becerilerinin etkilenmesiyle oluşur...</p>"
  },
    {
    "id": 4,
    "slug": "afazi-turleri",
    "title": "4Afazi Türleri Nelerdir? 5 Ana Tip ve Ayırt Edici Özellikleriyle Kapsamlı Rehber",
    "metaDescription": "Afazi türleri hakkında merak ettiğiniz her şey burada! Broca, Wernicke, Global ve diğer afazi çeşitlerini belirtileriyle birlikte öğrenin.",
    "keywords": ["Afazi türleri", "Broca afazisi", "Wernicke afazisi", "Global afazi", "Afazi nedir"],
    "category": "Bültenler",
    "image": "/images/afazi-turleri.png",
    "date": "2025-07-30",
    "featured": false,
    "content": "<h2>Afazi Nedir?</h2><p>Afazi, beyin hasarı sonucu dil becerilerinin etkilenmesiyle oluşur...</p>"
  },
      {
    "id": 5,
    "slug": "afazi-turleri",
    "title": "5Afazi Türleri Nelerdir? 5 Ana Tip ve Ayırt Edici Özellikleriyle Kapsamlı Rehber",
    "metaDescription": "Afazi türleri hakkında merak ettiğiniz her şey burada! Broca, Wernicke, Global ve diğer afazi çeşitlerini belirtileriyle birlikte öğrenin.",
    "keywords": ["Afazi türleri", "Broca afazisi", "Wernicke afazisi", "Global afazi", "Afazi nedir"],
    "category": "Bültenler",
    "image": "/images/afazi-turleri.png",
    "date": "2025-07-30",
    "featured": false,
    "content": "<h2>Afazi Nedir?</h2><p>Afazi, beyin hasarı sonucu dil becerilerinin etkilenmesiyle oluşur...</p>"
  }
]

;

export default blogs;
